import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BusquedaTesoroResultadoRondaPage } from '@pages';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';
import * as moment from 'moment';

@IonicPage()
@Component({
  selector: 'page-busqueda-tesoro-pregunta',
  templateUrl: 'busqueda-tesoro-pregunta.html',
})
export class BusquedaTesoroPreguntaPage implements AfterViewInit {

  @ViewChild('timer', { read: ElementRef }) timer: ElementRef;
  preguntas: Array<any>;
  busquedaDelTesoro: any;
  avanceID: string;
  nombreSede: string;
  objetivo: any;

  counterBack: number;
  interval: any;

  preguntaActual: any;
  respuestaActual: any;
  enEsperaRespuesta: boolean;

  estadisticas: Array<any>;

  tiempoInicio: any;
  puntosGanados: number;
  nivel: any;

  totalVidas: Array<any>;

  readonly AUDIO_CORRECTA = 'assets/audios/busqueda-tesoro/correcta.mp3';
  readonly AUDIO_INCORRECTA = 'assets/audios/busqueda-tesoro/incorrecto.mp3';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private busquedaTesoroProvider: BusquedaTesoroProvider,
  ) {
    this.preguntas         = this.navParams.get('preguntas');
    this.busquedaDelTesoro = this.navParams.get('busquedaDelTesoro');
    this.avanceID          = this.navParams.get('avanceID');
    this.nombreSede        = this.navParams.get('nombreSede');
    this.objetivo          = this.navParams.get('objetivo');
    this.nivel             = this.navParams.get('nivel');
    this.estadisticas      = [];
    this.counterBack       = 10;
    this.puntosGanados     = 0;

    const totalVidas       = this.objetivo.TOTAL_PREGUNTAS - this.objetivo.TOTAL_CORRECTAS;
    this.totalVidas        = Array.from(Array(totalVidas).keys()).map( i => ({ indice: i, src: 'assets/imgs/vida-activa.svg' }));
  }

  ionViewDidLoad() { }

  ngAfterViewInit() {
    this.obtenPreguntaActual();
  }

  iniciaCounterBack() {
    this.counterBack = 10;

    this.timer.nativeElement.style.animationPlayState = '';
    this.timer.nativeElement.style.animation = '';

    setTimeout(() => {
      this.timer.nativeElement.style.animation = 'countdown 10s linear  forwards';
    });

    this.interval = setInterval( () => {
      if(this.counterBack > 0) {
        this.counterBack--;
      }
    }, 1000);
  }

  cancelaInterval() {
    clearInterval(this.interval);
  }

  async verificaVidas() {
    let totalIncorrectas = this.estadisticas.filter( p => !p.esCorrecta).length;

    if(totalIncorrectas > this.totalVidas.length ) {
      let response = await this.busquedaTesoroProvider.actualizaEstadisticas(this.avanceID, this.estadisticas);

      this.navCtrl.setRoot(BusquedaTesoroResultadoRondaPage, {
        esCompletado: response.esCompletado,
        premio: response.premio,
        preguntas: this.preguntas,
        busquedaDelTesoro: this.busquedaDelTesoro,
        avanceID: this.avanceID,
        nombreSede: this.nombreSede,
        objetivo: this.objetivo,
        nivel: this.nivel
      });
    }
  }

  async obtenPreguntaActual() {
    this.enEsperaRespuesta = true;

    await this.verificaVidas();

    let pregunta = this.preguntas.pop();

    if(pregunta) {
      this.iniciaCounterBack();
      this.tiempoInicio = moment();
      let opciones = [
        pregunta.opcion1,
        pregunta.opcion2,
        pregunta.opcion3,
        pregunta.opcion4
      ];

      this.preguntaActual = pregunta;
      this.preguntaActual.opciones = opciones;
    } else {
      let response = await this.busquedaTesoroProvider.actualizaEstadisticas(this.avanceID, this.estadisticas);

      this.navCtrl.setRoot(BusquedaTesoroResultadoRondaPage, {
        esCompletado: response.esCompletado,
        premio: response.premio,
        preguntas: this.preguntas,
        busquedaDelTesoro: this.busquedaDelTesoro,
        avanceID: this.avanceID,
        nombreSede: this.nombreSede,
        objetivo: this.objetivo,
        nivel: this.nivel,
      });
    }
  }

  async handleRespuesta({ opcion, index }) {
    if(!this.enEsperaRespuesta) return;

    this.enEsperaRespuesta = false;
    this.timer.nativeElement.style.animationPlayState = 'paused';
    this.cancelaInterval();

    let tiempo = this.obtenTiempoRespuesta();
    this.calculaPuntos();

    this.respuestaActual = opcion;
    this.respuestaActual.index = index;
    this.estadisticas.push({
      pregunta: this.preguntaActual._id,
      esCorrecta: opcion.esCorrecta,
      tiempo: tiempo,
      puntos: opcion.esCorrecta ? this.puntosGanados: 0,
    });

    let audio = new Audio();
    if(opcion.esCorrecta) {
      audio.src = this.AUDIO_CORRECTA;
    } else {
      audio.src = this.AUDIO_INCORRECTA;
    }
    audio.load();
    audio.play();

    let totalIncorrectas = this.estadisticas.filter( p => !p.esCorrecta).length;

    this.totalVidas = this.totalVidas.map( i => {
      if(i.indice < totalIncorrectas) {
        i.src =  'assets/imgs/vida-inactiva.svg';
      }

      return i;
    });
  }

  obtenTiempoRespuesta() {
    let now = moment();
    let then = this.tiempoInicio;

    return now.diff(then, 'seconds', true);
  }

  calculaPuntos() {
    const TIEMPO_PARA_RESPONDER = 10;
    const PUNTOS_POR_TIEMPO = 2;
    const tiempoRespuesta = this.obtenTiempoRespuesta();

    this.puntosGanados = TIEMPO_PARA_RESPONDER;

    const fraccion = TIEMPO_PARA_RESPONDER / 4;

    if (tiempoRespuesta >= 0 && tiempoRespuesta < fraccion) {
      this.puntosGanados += PUNTOS_POR_TIEMPO * 4;
    }

    if (tiempoRespuesta >= fraccion && tiempoRespuesta < fraccion * 2) {
      this.puntosGanados += PUNTOS_POR_TIEMPO * 3;
    }

    if (tiempoRespuesta >= fraccion * 2 && tiempoRespuesta < fraccion * 3) {
      this.puntosGanados += PUNTOS_POR_TIEMPO * 2;
    }

    if (tiempoRespuesta >= fraccion * 3 && tiempoRespuesta < fraccion * 4) {
      this.puntosGanados += PUNTOS_POR_TIEMPO;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-pregunta/busqueda-tesoro-pregunta.ts